import { render, staticRenderFns } from "./headNav.vue?vue&type=template&id=2da4a5b6&scoped=true"
import script from "./headNav.vue?vue&type=script&lang=js"
export * from "./headNav.vue?vue&type=script&lang=js"
import style0 from "./headNav.vue?vue&type=style&index=0&id=2da4a5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4a5b6",
  null
  
)

export default component.exports